var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { logError } from 'hx-analytics/src/functions/logging/log-error.helper';
export function sendAnalyticsEvent(event) {
    var _a;
    return __awaiter(this, void 0, Promise, function () {
        var endpoint, data, payload, url, response, _b, error_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    endpoint = event.endpoint, data = __rest(event, ["endpoint"]);
                    payload = [
                        { capture_timestamp: Math.floor(Date.now() / 1000), event: data },
                    ];
                    url = "".concat(process.env.REACT_APP_ANALYTICS_API_URL, "/").concat(endpoint);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'X-Api-Key': (_a = process.env.REACT_APP_ANALYTICS_API_KEY) !== null && _a !== void 0 ? _a : '',
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                            },
                            body: JSON.stringify(payload),
                        })];
                case 2:
                    response = _d.sent();
                    if (response.ok)
                        return [2 /*return*/];
                    _b = logError;
                    _c = {
                        error: new Error("Analytics request failed with status: ".concat(response.status))
                    };
                    return [4 /*yield*/, response.text()];
                case 3:
                    _b.apply(void 0, [(_c.message = _d.sent(),
                            _c.tag = {
                                name: 'analytics-request',
                                value: 'failed',
                            },
                            _c.level = 'error',
                            _c.metadata = {
                                request: { url: url, method: 'POST' },
                                response: response,
                                event: event,
                            },
                            _c)]);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _d.sent();
                    logError({
                        error: error_1,
                        message: 'Analytics request failed',
                        tag: {
                            name: 'analytics-request',
                            value: 'network-error',
                        },
                        level: 'error',
                        metadata: {
                            request: { url: url, method: 'POST' },
                            event: event,
                        },
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
